// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 705 ? "dc112a36" : chunkId) + "." + {"424":"275613b9394bd933","705":"be31c562b623266d"}[chunkId] + ".js";
};